<template>
    <div class="card">
      <h3 class="card-title">{{ campaign.name }}</h3>
      <p class="card-description">{{ campaign.description }}</p>
      <div class="card-details">
        <p><strong>Amount Collected:</strong> {{ campaign.collected }}</p>
        <p><strong>Target:</strong> {{ campaign.target }}</p>
      </div>
      <button class="copy-button" @click="copyCampaignInfo">Copy Campaign Info</button>
    </div>
  </template>
  
  <script>
  export default {
    name: "CampaignCard",
    data() {
      return {
        campaign: {
          name: "Education Fundraiser",
          description: "Helping kids get back to school.",
          collected: "KES 250,000",
          target: "KES 500,000",
        },
      };
    },
    methods: {
      copyCampaignInfo() {
        const dataToCopy = `Campaign: ${this.campaign.name}\nDescription: ${this.campaign.description}\nCollected: ${this.campaign.collected}\nTarget: ${this.campaign.target}`;
        navigator.clipboard.writeText(dataToCopy).then(() => {
          alert("Campaign info copied to clipboard!");
        });
      },
    },
  };
  </script>
  
  <style scoped>
  .card {
    background: linear-gradient(145deg, #ffffff, #f1f1f1);
    border-radius: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    padding: 20px;
    width: 350px;
    margin: auto;
    text-align: center;
    transition: transform 0.3s, box-shadow 0.3s;
  }
  
  .card:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 15px rgba(0, 0, 0, 0.2);
  }
  
  .card-title {
    font-size: 1.8rem;
    color: #2a9d8f;
    margin-bottom: 10px;
    font-weight: bold;
  }
  
  .card-description {
    font-size: 1rem;
    color: #555;
    margin-bottom: 15px;
  }
  
  .card-details {
    font-size: 0.9rem;
    color: #333;
    margin-bottom: 15px;
  }
  
  .card-details p {
    margin: 5px 0;
  }
  
  .copy-button {
    background: #e63946;
    color: white;
    border: none;
    border-radius: 5px;
    padding: 10px 15px;
    cursor: pointer;
    font-size: 0.9rem;
    transition: background 0.3s, transform 0.2s;
  }
  
  .copy-button:hover {
    background: #c81c30;
    transform: scale(1.05);
  }
  </style>
  